import DepartmentPlanCard from "../DepartmentsPlan/DepartmentPlanCard";
import { useDepartmentPlanById } from "./useDepartmentPlanById";
import { useWorkspace } from "@/features/Workspace/lib/useWorkspace";
import { useDashboard } from "../../../lib/useDashboard";
import { useAuth } from "@/features/Auth/lib/useAuth";
import { useDepartmentForecastPlan } from "./useDepartmentForecastPlan";
import { useNavigate } from 'react-router-dom';

function getDepartmentName(departmentId: number, departments: { id: number; name: string }[]): string {
  const dep = departments.find((d) => d.id === departmentId);
  return dep?.name ?? `Отдел ${departmentId}`;
}

function DepartmentPlan({ col = 15, row = 10 }: { col?: number; row?: number } = {}) {
  const { selectedDepartment, dateStart, dateEnd } = useDashboard();
  const { user } = useAuth();
  const departmentId =
    selectedDepartment != null && selectedDepartment !== ""
      ? Number(selectedDepartment)
      : user?.bx?.department?.[0]?.id ?? undefined;
  const { departments } = useWorkspace();
  const { opportunity, profit, loading, error } = useDepartmentPlanById(departmentId);
  const forecast = useDepartmentForecastPlan(departmentId, dateStart, dateEnd);
  const navigate = useNavigate();

  const showCard =
    departmentId != null &&
    (loading ||
      (opportunity != null && (opportunity.target ?? 0) > 0) ||
      (profit != null && (profit.target ?? 0) > 0));

  if (!showCard) return null;

  const deptName = getDepartmentName(departmentId!, departments);
  const openAnalytics = () => {
    if (!dateStart || !dateEnd) return;
    const query = new URLSearchParams({
      scope: 'department', departmentId: String(departmentId), dateStart, dateEnd,
    });
    navigate(`/SalePlan/analytics?${query.toString()}`);
  };

  return (
    <>
      <DepartmentPlanCard
        title={deptName}
        col={col}
        row={row}
        loading={loading}
        error={error}
        opportunity={opportunity}
        profit={profit}
        opportunityForecast={forecast.opportunity}
        profitForecast={forecast.profit}
        onClick={openAnalytics}
      />
    </>
  );
}

export default DepartmentPlan;
